import _ from "lodash";
import BusinessConstants from "../constant/BusinessConstants";


const getAllUserTypeCodes = () => {
    return _.map(BusinessConstants.RENYUAN_USER_TYPE, item => item.code);
};

const getUserTypeOptions = () => {
    const options = _.map(BusinessConstants.RENYUAN_USER_TYPE, item => ({
        label: item.display,
        value: item.code,
    }));

    /* if (__IS_SWJW__) {
        options.push({
            label: BusinessConstants.USER_TYPE.NON_EMPLOYEE.display,
            value: BusinessConstants.UNIT_TYPE.NON_EMPLOYEE.code,
        });
    } */
    options.push({
        label: BusinessConstants.USER_TYPE.NON_EMPLOYEE.display,
        value: BusinessConstants.USER_TYPE.NON_EMPLOYEE.code,
    });

    return options;
};

const getUserTypesParam = (selectedUserTypes) => {
    const allUserTypeCodes = getAllUserTypeCodes();

    if (_.isEmpty(selectedUserTypes) || _.size(selectedUserTypes) === _.size(allUserTypeCodes)) {
        return undefined;
    }

    return selectedUserTypes;
};

export default {
    getAllUserTypeCodes,
    getUserTypeOptions,
    getUserTypesParam,
};
